import { render } from "./Badge_journey.vue?vue&type=template&id=646d2162&scoped=true"
import script from "./Badge_journey.vue?vue&type=script&lang=js"
export * from "./Badge_journey.vue?vue&type=script&lang=js"

import "./Badge_journey.vue?vue&type=style&index=0&id=646d2162&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646d2162"]])

export default __exports__